import { render } from "./CreateTermsAndConditions.vue?vue&type=template&id=328f053f"
import script from "./CreateTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./CreateTermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__